"use client";

import { Checkbox, Dropdown, Icon } from "@kyan/ui";

export interface Columns {
  open: boolean;
  rho: boolean;
  theta: boolean;
  vega: boolean;
  gamma: boolean;
  delta: boolean;
  bidSize: boolean;
  ivBid: boolean;
  bid: boolean;
  mark: boolean;
  ask: boolean;
  ivAsk: boolean;
  askSize: boolean;
  position: boolean;
}

const items: {
  id: keyof Columns;
  label: string;
  disable: boolean;
}[] = [
  {
    id: "open",
    label: "Open",
    disable: false,
  },
  {
    id: "rho",
    label: "Rho",
    disable: false,
  },
  {
    id: "theta",
    label: "Theta",
    disable: false,
  },
  {
    id: "vega",
    label: "Vega",
    disable: false,
  },
  {
    id: "gamma",
    label: "Gamma",
    disable: false,
  },
  {
    id: "delta",
    label: "Delta",
    disable: false,
  },
  {
    id: "bidSize",
    label: "Bid Size",
    disable: false,
  },
  {
    id: "ivBid",
    label: "IV Bid",
    disable: false,
  },
  {
    id: "bid",
    label: "Bid",
    disable: true,
  },
  {
    id: "mark",
    label: "Mark",
    disable: false,
  },
  {
    id: "ask",
    label: "Ask",
    disable: true,
  },
  {
    id: "ivAsk",
    label: "IV Ask",
    disable: false,
  },
  {
    id: "askSize",
    label: "Ask Size",
    disable: false,
  },
  {
    id: "position",
    label: "Position",
    disable: false,
  },
];

export interface ColumnsDropdownProps {
  value: Columns;
  onChange?: (value: Columns) => void;
}

export const ColumnsDropdown: React.FC<ColumnsDropdownProps> = ({
  value,
  onChange,
}) => {
  const showAll = Object.values(value).every((v) => v);

  const handleChange = (checked: boolean, id: keyof Columns) => {
    onChange?.({
      ...value,
      [id]: checked,
    });
  };

  const handleShowAll = () => {
    const excludeColumns = ["volume", "rho", "theta", "vega", "gamma"];

    const idValuePairs = items.map(({ id }) => [
      id,
      !showAll || !excludeColumns.includes(id),
    ]);

    onChange?.(Object.fromEntries(idValuePairs) as Columns);
  };

  return (
    <Dropdown
      align="start"
      sideOffset={4}
      trigger={
        <button className="bg-buttonBg dark:bg-buttonFill hover:text-textPrimary hover:bg-buttonHover flex cursor-pointer items-center gap-1 rounded-xs p-2 text-xs transition-colors">
          <span>Columns</span>
          <Icon name="settings" className="text-xs" />
        </button>
      }
    >
      <ul className="bg-background border-divider rounded-sm shadow-[0px_2px_14px_0px_rgba(201,201,201,0.50)] dark:border dark:shadow-none">
        <li className="border-divider hover:bg-buttonHover list-none border-b p-2 transition-colors">
          <Checkbox
            value={showAll}
            label={`Show all (${items.length.toString()})`}
            onValueChange={handleShowAll}
          />
        </li>

        {items.map((item) => (
          <li
            key={item.label}
            className="hover:bg-buttonHover list-none p-2 transition-colors"
          >
            <Checkbox
              label={item.label}
              value={value[item.id]}
              disabled={item.disable}
              onValueChange={(checked) => {
                handleChange(checked, item.id);
              }}
            />
          </li>
        ))}
      </ul>
    </Dropdown>
  );
};
